import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface CreatePersonalAccessTokenParams {
  clientId: string;
}

export interface CreatePersonalAccessTokenResult  extends IResult {
  refreshToken: string;
}

export class CreatePersonalAccessTokenRequest extends Request<CreatePersonalAccessTokenParams, CreatePersonalAccessTokenResult> {
  constructor(params: CreatePersonalAccessTokenParams) {
    super('createPersonalAccessToken', params);
  }
}
